// src/App.js
import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Navbar from "./components/Navbar";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import MasterDashboard from "./pages/master/Dashboard";
import SuperAdminManagement from "./pages/master/SuperAdminManagement";
import SuperAdminDashboard from "./pages/superadmin/Dashboard";
import Account from "./pages/superadmin/Account";
import UsersManagement from "./pages/superadmin/UsersManagement";
import UserManagement from "./pages/master/UserManagement";
import ProtectedRoute from "./components/ProtectedRoute";
import VerifyEmail from "./pages/VerifyEmail";
import ForgotPassword from "./pages/ForgotPassword";
import UserDashboard from "./pages/user/UserDashboard";
import PaidUserDashboard from "./pages/user/PaidUserDashboard";
import BankManagement from "./pages/master/BankManagement";
import PlanManagement from "./pages/master/PlanManagement";
import PaymentSuccess from "./pages/user/PaymentSuccess";
import CreateProject from "./pages/user/CreateProject";
import EarningsPage from "./pages/superadmin/EarningsPage";
import ProjectInputPage from "./pages/paidProject/ProjectInputPage";
import PaidProjectLayout from "./layouts/PaidProjectLayout";
import PlantMachinery from "./pages/paidProject/Annexure 1/PlantMachinery";
import FurnitureAndFixture from "./pages/paidProject/Annexure 1/FurnitureAndFixture";
import OtherFixedAssets from "./pages/paidProject/Annexure 1/OtherFixedAssets";
import ComputerSoftware from "./pages/paidProject/Annexure 1/ComputerSoftware";
import PreliminaryExpenses from "./pages/paidProject/Annexure 1/PreliminaryExpenses";
import Depreciation from "./pages/paidProject/Annexure 1/Depreciation";
import Consumables from "./pages/paidProject/Annexure 1/Consumables";
import CalculateLabour from "./pages/paidProject/Annexure 1/CalculateLabour";
import Power from "./pages/paidProject/Annexure 1/Power";
import RMConsumption from "./pages/paidProject/Annexure 1/RMConsumption";
import CostOfProduction from "./pages/paidProject/Annexure 1/CostOfProduction";
import AnnualSalesRealisation from "./pages/paidProject/Annexure 1/AnnualSalesRealisation";
import TermLoanRepayment from "./pages/paidProject/Annexure 1/TermLoanRepayment";
import FinanceCharges from "./pages/paidProject/Annexure 1/FinanceCharges";
import WorkingCapitalPage from "./pages/paidProject/Annexure 1/WorkingCapitalPage";
import ProjectedProfitability from "./pages/paidProject/Annexure 1/ProjectedProfitability";
import BreakEvenPointAnalysis from "./pages/paidProject/Annexure 1/BreakEvenPointAnalysis";
import ProjectedBalanceSheet from "./pages/paidProject/Annexure 1/ProjectedBalanceSheet";
import ProjectedCashFlow from "./pages/paidProject/Annexure 1/ProjectedCashFlow";
import SensitivityAnalysis from "./pages/paidProject/Annexure 1/SensitivityAnalysis";
import FinancialIndicators from "./pages/paidProject/Annexure 1/FinancialIndicators";
import CostOfTheProject from "./pages/paidProject/Annexure 1/CostOfTheProject";
import ReportPage from "./pages/paidProject/ReportPage";
import GuidelinesManagement from "./pages/master/GuidelinesManagement";
import Footer from "./components/Footer";

function App() {
  // keep your global print-block if you still want it
  useEffect(() => {
    const handlePrintShortcut = (e) => {
      if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === "p") {
        e.preventDefault();
        alert("Printing is disabled on this page."); // optional
      }
    };

    window.addEventListener("keydown", handlePrintShortcut);
    return () => window.removeEventListener("keydown", handlePrintShortcut);
  }, []);

  return (
    <Router>
      {/* pb-16 so content doesn't hide behind the footer height */}
      <div className="min-h-screen flex flex-col bg-gray-50 pb-16">
        <Navbar />

        <main className="flex-1">
          <Routes>
            <Route path="/signup" element={<Signup />} />
            <Route path="/login" element={<Login />} />
            <Route path="/verify-email" element={<VerifyEmail />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/payment-success" element={<PaymentSuccess />} />

            {/* Master */}
            <Route
              path="/master"
              element={
                <ProtectedRoute allowedRoles={["master"]}>
                  <MasterDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/master/superadmins"
              element={
                <ProtectedRoute allowedRoles={["master"]}>
                  <SuperAdminManagement />
                </ProtectedRoute>
              }
            />
            <Route
              path="/master/guidelines"
              element={
                <ProtectedRoute allowedRoles={["master"]}>
                  <GuidelinesManagement />
                </ProtectedRoute>
              }
            />
            <Route
              path="/master/users"
              element={
                <ProtectedRoute allowedRoles={["master"]}>
                  <UserManagement />
                </ProtectedRoute>
              }
            />
            <Route
              path="/master/banks"
              element={
                <ProtectedRoute allowedRoles={["master"]}>
                  <BankManagement />
                </ProtectedRoute>
              }
            />
            <Route
              path="/master/plans"
              element={
                <ProtectedRoute allowedRoles={["master"]}>
                  <PlanManagement />
                </ProtectedRoute>
              }
            />

            {/* SuperAdmin */}
            <Route
              path="/superadmin"
              element={
                <ProtectedRoute allowedRoles={["superadmin"]}>
                  <SuperAdminDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/superadmin/users"
              element={
                <ProtectedRoute allowedRoles={["superadmin"]}>
                  <UsersManagement />
                </ProtectedRoute>
              }
            />
            <Route
              path="/superadmin/account"
              element={
                <ProtectedRoute allowedRoles={["superadmin"]}>
                  <Account />
                </ProtectedRoute>
              }
            />
            <Route
              path="/superadmin/earnings"
              element={
                <ProtectedRoute allowedRoles={["superadmin"]}>
                  <EarningsPage />
                </ProtectedRoute>
              }
            />

            {/* Single user home */}
            <Route path="/user/create-project" element={<CreateProject />} />
            <Route
              path="/user"
              element={
                <ProtectedRoute allowedRoles={["user"]}>
                  <UserDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/user/create-project/:id"
              element={
                <ProtectedRoute allowedRoles={["user"]}>
                  <CreateProject />
                </ProtectedRoute>
              }
            />
            {/* (You had this duplicate /user route before; leaving it as-is) */}
            <Route
              path="/user"
              element={
                <ProtectedRoute allowedRoles={["user"]}>
                  <PaidUserDashboard />
                </ProtectedRoute>
              }
            />

            {/* Project inputs & reports – NO extra id guard now */}
            <Route
              path="/project-inputs/:projectId"
              element={<PaidProjectLayout />}
            >
              <Route index element={<ProjectInputPage />} />
              <Route path="report" element={<ReportPage />} />
              <Route
                path="cost-of-the-project"
                element={<CostOfTheProject />}
              />
              <Route path="plant-machinery" element={<PlantMachinery />} />
              <Route
                path="furniture-fixture"
                element={<FurnitureAndFixture />}
              />
              <Route path="other-fixed-assets" element={<OtherFixedAssets />} />
              <Route path="computer-software" element={<ComputerSoftware />} />
              <Route
                path="preliminary-expenses"
                element={<PreliminaryExpenses />}
              />
              <Route path="depreciation" element={<Depreciation />} />
              <Route path="consumables" element={<Consumables />} />
              <Route path="calculate-labour" element={<CalculateLabour />} />
              <Route path="power" element={<Power />} />
              <Route path="rm-consumption" element={<RMConsumption />} />
              <Route path="cost-of-production" element={<CostOfProduction />} />
              <Route path="annual-sales" element={<AnnualSalesRealisation />} />
              <Route
                path="term-loan-repayment"
                element={<TermLoanRepayment />}
              />
              <Route path="finance-charges" element={<FinanceCharges />} />
              <Route
                path="working-capital-requirement"
                element={<WorkingCapitalPage />}
              />
              <Route
                path="projected-profitability"
                element={<ProjectedProfitability />}
              />
              <Route
                path="break-even-point-analysis"
                element={<BreakEvenPointAnalysis />}
              />
              <Route
                path="projected-balance-sheet"
                element={<ProjectedBalanceSheet />}
              />
              <Route
                path="projected-cash-flow"
                element={<ProjectedCashFlow />}
              />
              <Route
                path="sensitivity-analysis"
                element={<SensitivityAnalysis />}
              />
              <Route
                path="financial-indicators"
                element={<FinancialIndicators />}
              />
            </Route>

            {/* Default */}
            <Route path="*" element={<Login />} />
          </Routes>
        </main>

        {/* Sticky footer pinned to bottom of viewport */}
        <div className="fixed bottom-0 left-0 w-full z-20">
          <Footer />
        </div>
      </div>
    </Router>
  );
}

export default App;
